module.exports = __webpack_public_path__ + "mobile.a6610c5d.webp";